module.exports = __webpack_public_path__ + "static/team-4-237c2c5ea3583f893d95b59b12d5716b.jpg";